import { render, staticRenderFns } from "./EffectChain.vue?vue&type=template&id=79dfe012&scoped=true&"
import script from "./EffectChain.vue?vue&type=script&lang=js&"
export * from "./EffectChain.vue?vue&type=script&lang=js&"
import style0 from "./EffectChain.vue?vue&type=style&index=0&id=79dfe012&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dfe012",
  null
  
)

export default component.exports